import { buildModelManager } from "../builder.js";
const DefaultLeakedCodeSelection = {
  __typename: true,
  id: true,
  code: true,
  codeEndsAt: true,
  codeStartsAt: true,
  createdAt: true,
  emailAlertSent: true,
  isCurrentlyLeaked: true,
  isHighRisk: true,
  lastScrapedAt: true,
  leakSources: true,
  leakedSiteMetadata: true,
  shopId: true,
  shopifyDiscountCodeId: true,
  shopifyPriceRuleId: true,
  updatedAt: true,
  usageCount: true,
  value: true,
  valueType: true
};
const modelApiIdentifier = "leakedCode";
const pluralModelApiIdentifier = "leakedCodes";
;
;
;
;
;
;
;
;
;
const LeakedCodeManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultLeakedCodeSelection,
  [
    {
      type: "findOne",
      operationName: modelApiIdentifier,
      modelApiIdentifier,
      findByVariableName: "id",
      defaultSelection: DefaultLeakedCodeSelection,
      namespace: null
    },
    {
      type: "maybeFindOne",
      operationName: modelApiIdentifier,
      modelApiIdentifier,
      findByVariableName: "id",
      defaultSelection: DefaultLeakedCodeSelection,
      namespace: null
    },
    {
      type: "findMany",
      operationName: pluralModelApiIdentifier,
      modelApiIdentifier,
      defaultSelection: DefaultLeakedCodeSelection,
      namespace: null
    },
    {
      type: "findFirst",
      operationName: pluralModelApiIdentifier,
      modelApiIdentifier,
      defaultSelection: DefaultLeakedCodeSelection,
      namespace: null
    },
    {
      type: "maybeFindFirst",
      operationName: pluralModelApiIdentifier,
      modelApiIdentifier,
      defaultSelection: DefaultLeakedCodeSelection,
      namespace: null
    },
    {
      type: "findOne",
      operationName: pluralModelApiIdentifier,
      functionName: "findById",
      findByField: "id",
      findByVariableName: "id",
      modelApiIdentifier,
      defaultSelection: DefaultLeakedCodeSelection,
      namespace: null
    },
    {
      type: "maybeFindOne",
      operationName: pluralModelApiIdentifier,
      functionName: "maybeFindById",
      findByField: "id",
      findByVariableName: "id",
      modelApiIdentifier,
      defaultSelection: DefaultLeakedCodeSelection,
      namespace: null
    },
    {
      type: "findOne",
      operationName: pluralModelApiIdentifier,
      functionName: "findByCode",
      findByField: "code",
      findByVariableName: "code",
      modelApiIdentifier,
      defaultSelection: DefaultLeakedCodeSelection,
      namespace: null
    },
    {
      type: "maybeFindOne",
      operationName: pluralModelApiIdentifier,
      functionName: "maybeFindByCode",
      findByField: "code",
      findByVariableName: "code",
      modelApiIdentifier,
      defaultSelection: DefaultLeakedCodeSelection,
      namespace: null
    },
    {
      type: "action",
      operationName: "createLeakedCode",
      operationReturnType: "CreateLeakedCode",
      functionName: "create",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: false,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: { leakedCode: { required: false, type: "CreateLeakedCodeInput" } },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: [],
      hasReturnType: false,
      acceptsModelInput: true,
      hasCreateOrUpdateEffect: true,
      defaultSelection: DefaultLeakedCodeSelection
    },
    {
      type: "action",
      operationName: "bulkCreateLeakedCodes",
      functionName: "bulkCreate",
      isBulk: true,
      isDeleter: false,
      hasReturnType: false,
      acceptsModelInput: true,
      operatesWithRecordIdentity: false,
      singleActionFunctionName: "create",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: {
        inputs: { required: true, type: "[BulkCreateLeakedCodesInput!]" }
      },
      paramOnlyVariables: [],
      defaultSelection: DefaultLeakedCodeSelection
    },
    {
      type: "action",
      operationName: "updateLeakedCode",
      operationReturnType: "UpdateLeakedCode",
      functionName: "update",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: true,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: {
        id: { required: true, type: "GadgetID" },
        leakedCode: { required: false, type: "UpdateLeakedCodeInput" }
      },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: [],
      hasReturnType: false,
      acceptsModelInput: true,
      hasCreateOrUpdateEffect: true,
      defaultSelection: DefaultLeakedCodeSelection
    },
    {
      type: "action",
      operationName: "bulkUpdateLeakedCodes",
      functionName: "bulkUpdate",
      isBulk: true,
      isDeleter: false,
      hasReturnType: false,
      acceptsModelInput: true,
      operatesWithRecordIdentity: true,
      singleActionFunctionName: "update",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: {
        inputs: { required: true, type: "[BulkUpdateLeakedCodesInput!]" }
      },
      paramOnlyVariables: [],
      defaultSelection: DefaultLeakedCodeSelection
    },
    {
      type: "action",
      operationName: "deleteLeakedCode",
      operationReturnType: "DeleteLeakedCode",
      functionName: "delete",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: true,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: true,
      variables: { id: { required: true, type: "GadgetID" } },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: [],
      hasReturnType: false,
      acceptsModelInput: false,
      hasCreateOrUpdateEffect: false,
      defaultSelection: null
    },
    {
      type: "action",
      operationName: "bulkDeleteLeakedCodes",
      functionName: "bulkDelete",
      isBulk: true,
      isDeleter: true,
      hasReturnType: false,
      acceptsModelInput: false,
      operatesWithRecordIdentity: true,
      singleActionFunctionName: "delete",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: { ids: { required: true, type: "[GadgetID!]" } },
      paramOnlyVariables: [],
      defaultSelection: null
    },
    {
      type: "action",
      operationName: "upsertLeakedCode",
      operationReturnType: "UpsertLeakedCode",
      functionName: "upsert",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: false,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: {
        on: { required: false, type: "[String!]" },
        leakedCode: { required: false, type: "UpsertLeakedCodeInput" }
      },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: ["on"],
      hasReturnType: {
        "... on CreateLeakedCodeResult": { hasReturnType: false },
        "... on UpdateLeakedCodeResult": { hasReturnType: false }
      },
      acceptsModelInput: true,
      hasCreateOrUpdateEffect: true,
      defaultSelection: DefaultLeakedCodeSelection
    },
    {
      type: "action",
      operationName: "bulkUpsertLeakedCodes",
      functionName: "bulkUpsert",
      isBulk: true,
      isDeleter: false,
      hasReturnType: false,
      acceptsModelInput: true,
      operatesWithRecordIdentity: false,
      singleActionFunctionName: "upsert",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: {
        inputs: { required: true, type: "[BulkUpsertLeakedCodesInput!]" }
      },
      paramOnlyVariables: ["on"],
      defaultSelection: DefaultLeakedCodeSelection
    }
  ]
);
export {
  DefaultLeakedCodeSelection,
  LeakedCodeManager
};
//# sourceMappingURL=LeakedCode.js.map
